/**
 * Homebase — Parallax scroll effect for hero banner
 */
(function () {
  'use strict';

  let heroImg = null;
  let heroBanner = null;
  let ticking = false;

  function initParallax() {
    // Find the hero section (custom hb-hero or Dawn image-banner)
    heroBanner = document.querySelector(
      '[id*="__hb_hero"] .banner, [id*="__image_banner"] .banner'
    );
    if (!heroBanner) return;

    heroImg = heroBanner.querySelector('.banner__image, .banner__media img');
    if (!heroImg) return;

    heroImg.style.willChange = 'transform';
    heroImg.style.transition = 'none';

    // Make sure the media container clips the overflowing image
    const media = heroImg.closest('.banner__media');
    if (media) {
      media.style.overflow = 'hidden';
      media.style.position = 'absolute';
      media.style.inset = '0';
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    applyParallax();
  }

  function onScroll() {
    if (!ticking) {
      requestAnimationFrame(applyParallax);
      ticking = true;
    }
  }

  function applyParallax() {
    ticking = false;
    if (!heroImg || !heroBanner) return;

    const rect = heroBanner.getBoundingClientRect();
    const viewportH = window.innerHeight;

    if (rect.bottom < 0 || rect.top > viewportH) return;

    // shift: positive = image moves down (shows upper portion), negative = moves up
    // At page top (rect.top = 0) shift = 0. As user scrolls down, rect.top goes negative → shift goes positive
    const progress = -rect.top / viewportH; // 0 at top, 1 when scrolled past
    const shift = progress * 80; // max 80px movement

    heroImg.style.transform = `translateY(${shift}px)`;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initParallax);
  } else {
    initParallax();
  }
})();
